import { Link } from 'react-router-dom'

export const MainFooter = () => {
  return (
    <footer className="MainFooter border-t-thin border-t-tint-gray-100 bg-base pointer-events-auto relative z-[100] flex h-full w-full items-center justify-center">
      <div className="MainFooter__disclosures bg-base relative z-[100] flex flex-wrap items-center justify-center gap-x-3 py-2 text-xs font-light">
        <span className="Copyright__year">
          &copy; {new Date().getFullYear()} El Toro
        </span>
        <span className="MainFooter__divider text-tint-gray-300">|</span>
        <Link
          to="https://eltoro.com/privacy-policy/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </Link>
        <span className="MainFooter__divider text-tint-gray-300">|</span>
        <Link to="/aup">Acceptable Use Policy</Link>
        <span className="MainFooter__divider text-tint-gray-300">|</span>
        <Link to="/dpa">Data Processing Agreement</Link>
      </div>
    </footer>
  )
}
